import { ReactNode } from 'react';
import SelectBox from './SelectBox';

export type getHtmlHandler = (source: string, searchText: string) => string;
export type RenderOptionType = (
	item: any,
	isSelected: boolean,
	searchText: string,
	index: number,
	getHtml: getHtmlHandler,
) => ReactNode;

export default SelectBox;
